/**
 * The line an unpublished event's card carries under its details.
 *
 * Its admin reaches the administration page from the card, so they are told
 * the public page does not exist yet and where publishing happens. Anyone
 * else has a card that leads nowhere yet, and being told why is what stops it
 * reading as broken.
 */
export const UNPUBLISHED_ADMIN_NOTE =
  "Draft · the event page is not public yet. Publish it in Settings.";
export const UNPUBLISHED_MEMBER_NOTE =
  "Not published yet. It opens here once the organisers publish it.";

export function unpublishedNote(isEventAdmin: boolean): string {
  return isEventAdmin ? UNPUBLISHED_ADMIN_NOTE : UNPUBLISHED_MEMBER_NOTE;
}
